import { customElement, FASTElement, observable, attr } from '@microsoft/fast-element';
import { IndividualProjectVppasStyles as styles } from './individual-projects-vppas.style';
import { IndividualProjectVppasTemplate as template } from './individual-projects-vppas.template';
import { PRODUCT_TYPE } from '../../../../utils';
import { IndividualProjectVppasGrid } from '../individual-projects-vppas-grid/individual-projects-vppas-grid';
import { ICompanyService } from '../../../../services/company.service';
import {IUserService} from "../../../../services/user.service";
import {VppaModal} from "../../../modals/vppa-modal/vppa-modal";
const name = 'individual-projects-vppas';

@customElement({
  name,
  template,
  styles,
})
export class IndividualProjectVppas extends FASTElement {
  @observable productType: PRODUCT_TYPE = PRODUCT_TYPE.VIRTUAL_PPA;
  @observable contractGridVppa: IndividualProjectVppasGrid;
  @observable contractGridRec: IndividualProjectVppasGrid;
  @observable contractGridPpa: IndividualProjectVppasGrid;
  @ICompanyService companyService: ICompanyService;
  @IUserService userService: IUserService;

  public vppaModal: VppaModal;

  connectedCallback() {
    super.connectedCallback()
    if(this.companyService.isNonSefParticipantAgreement()){
      this.allPpaGrid()
    } else {
      this.allVppaGrid()
    }
  }

  public allRecsGrid() {
    this.productType = PRODUCT_TYPE.RECS;
    this.$emit('productType', this.productType);
  }

  public allVppaGrid() {
    this.productType = PRODUCT_TYPE.VIRTUAL_PPA;
    this.$emit('productType', this.productType);
  }

  public allPpaGrid() {
    this.productType = PRODUCT_TYPE.PHYSICAL_PPA;
    this.$emit('productType', this.productType);
  }

  public downloadGridCsv() {
    if (this.productType === PRODUCT_TYPE.RECS) {
      this.contractGridRec.downloadGridCsv();
    } else if (this.productType === PRODUCT_TYPE.VIRTUAL_PPA) {
      this.contractGridVppa.downloadGridCsv();
    } else {
      this.contractGridPpa.downloadGridCsv();
    }
  }

  public openVppaModal() {
    this.$emit('openModal');
  }
}
